module.exports = __webpack_public_path__ + "img/add.7ab8a63d.svg";